import _defineProperty from '../../../../node_modules/@babel/runtime/helpers/defineProperty.es.js';
import _classCallCheck from '../../../../node_modules/@babel/runtime/helpers/classCallCheck.es.js';
import _createClass from '../../../../node_modules/@babel/runtime/helpers/createClass.es.js';
import _inherits from '../../../../node_modules/@babel/runtime/helpers/inherits.es.js';
import _possibleConstructorReturn from '../../../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.es.js';
import _getPrototypeOf from '../../../../node_modules/@babel/runtime/helpers/getPrototypeOf.es.js';
import { Transition } from '@mgmresorts/wcl-utils';
import focusTrap_1 from '../../../../node_modules/focus-trap/index.es.js';
import React from 'react';
import Portal from '../../../../node_modules/react-portal/es/PortalCompat.es.js';
import tether from '../../../../node_modules/tether/dist/js/tether.es.js';
import { EscKeyListenContext } from '../EscKeyListenContext/EscKeyListenContext.es.js';
import '../../../../node_modules/@babel/runtime/helpers/toConsumableArray.es.js';
import '../../../../node_modules/@babel/runtime/helpers/slicedToArray.es.js';
import { ZIndexContext } from '../ZIndexContext/ZIndexContext.es.js';
import { StyledAnimationWrapper, TRANSITION_DURATION, StyledWrapper, StyledInvertedAnimationWrapper, StyledScrollWrapper, StyledA11yCloseButton } from './DropdownDialog.styles.es.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var DropdownDialog = /*#__PURE__*/function (_React$Component) {
  _inherits(DropdownDialog, _React$Component);

  var _super = _createSuper(DropdownDialog);

  function DropdownDialog() {
    var _this;

    _classCallCheck(this, DropdownDialog);

    _this = _super.apply(this, arguments);
    _this._wrapperRef = /*#__PURE__*/React.createRef();

    _this._handleDocumentMouseClick = function (e) {
      if (!_this._wrapperRef.current) {
        return;
      }

      if (!_this.props.open) {
        return;
      }

      if (e.button && e.button !== 0) {
        return;
      }

      if (_this._wrapperRef.current.contains(e.target)) {
        return;
      }

      if (_this.props.triggerEl.contains(e.target)) {
        return;
      }

      if (_this.props.onClose) {
        _this.props.onClose();
      }
    };

    _this._handleTransitionEnter = function () {
      _this._initTether();
    }; // Side effects like those can be triggered after transition starts


    _this._handleTransitionEntering = function () {
      _this._createFocusTrap();

      _this._subscribeToEscKey();

      if (_this.props.closeOnOutsideClick) {
        // `true` is passed here intentionally as `useCapture` argument,
        // so that this event listener happens before `onClick` listeners inside of the components tree
        //
        // This will solve the bug in which dropdown is closed,
        // when click happens on an element inside of the dialog,
        // but is also destroyed synchronously by the component just after the the click happens.
        // ( https://github.com/MGMResorts/web-gen3/pull/178/files#r291161787 )
        document.addEventListener('click', _this._handleDocumentMouseClick, true);
      }
    }; // Side effects like those can be triggered after transition starts


    _this._handleTransitionExiting = function () {
      document.removeEventListener('click', _this._handleDocumentMouseClick, true);

      _this._unsubscribeFromEscKey();

      _this._removeFocusTrap();
    };

    _this._handleTransitionExited = function () {
      _this._destroyTether();
    };

    _this._handleTransitionAddEndListener = function (node, done) {
      var innerNode = node.querySelector("".concat(StyledAnimationWrapper));

      if (innerNode) {
        innerNode.addEventListener('transitionend', done, false);
      }
    };

    return _this;
  }

  _createClass(DropdownDialog, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      if (this._tether) {
        // update the position if content has changed
        this._tether.position();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._destroyTether();
    }
  }, {
    key: "focusTrapOptions",
    get: function get() {
      return _objectSpread({
        returnFocusOnDeactivate: true,
        setInitialFocusToDialog: true,
        setFallbackFocusToDialog: true
      }, this.props.focusTrapOptions);
    }
  }, {
    key: "_subscribeToEscKey",
    value: function _subscribeToEscKey() {
      var _this$props = this.props,
          closeOnEsc = _this$props.closeOnEsc,
          onClose = _this$props.onClose;

      if (closeOnEsc) {
        this._escKeySubscription = this.context.subscribe(function () {
          if (closeOnEsc && onClose) {
            onClose();
          }
        });
      }
    }
  }, {
    key: "_unsubscribeFromEscKey",
    value: function _unsubscribeFromEscKey() {
      if (this._escKeySubscription) {
        this._escKeySubscription.unsubscribe();

        delete this._escKeySubscription;
      }
    }
  }, {
    key: "_initTether",
    value: function _initTether() {
      if (!this._wrapperRef.current) {
        console.error('this._wrapperRef.current is missing');
        return;
      }

      if (!this.props.triggerEl) {
        console.error('this.props.triggerEl is missing');
        return;
      }

      this._tether = new tether({
        element: this._wrapperRef.current,
        target: this.props.triggerEl,
        attachment: this.props.dialogAttachment,
        targetAttachment: this.props.triggerAttachment,
        constraints: this.props.constraints
      });

      this._tether.enable();
    }
  }, {
    key: "_destroyTether",
    value: function _destroyTether() {
      if (this._tether) {
        this._tether.destroy();
      }
    }
  }, {
    key: "_createFocusTrap",
    value: function _createFocusTrap() {
      if (!this.props.trapFocus) {
        return;
      }

      if (this._focusTrap) {
        return;
      }

      var _this$focusTrapOption = this.focusTrapOptions,
          returnFocusOnDeactivate = _this$focusTrapOption.returnFocusOnDeactivate,
          setInitialFocusToDialog = _this$focusTrapOption.setInitialFocusToDialog,
          setFallbackFocusToDialog = _this$focusTrapOption.setFallbackFocusToDialog;
      this._focusTrap = focusTrap_1(this._wrapperRef.current, {
        returnFocusOnDeactivate: returnFocusOnDeactivate,
        clickOutsideDeactivates: true,
        initialFocus: setInitialFocusToDialog ? this._wrapperRef.current : undefined,
        fallbackFocus: setFallbackFocusToDialog ? this._wrapperRef.current : undefined
      });

      this._focusTrap.activate();
    }
  }, {
    key: "_removeFocusTrap",
    value: function _removeFocusTrap() {
      if (this._focusTrap) {
        this._focusTrap.deactivate();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          minWidth = _this$props2.minWidth,
          includeA11yCloseButton = _this$props2.includeA11yCloseButton,
          children = _this$props2.children,
          maxHeight = _this$props2.maxHeight,
          ariaLabel = _this$props2['aria-label'],
          offsetTop = _this$props2.offsetTop,
          className = _this$props2.className,
          isOpen = _this$props2.open;
      var _this$focusTrapOption2 = this.focusTrapOptions,
          setInitialFocusToDialog = _this$focusTrapOption2.setInitialFocusToDialog,
          setFallbackFocusToDialog = _this$focusTrapOption2.setFallbackFocusToDialog;
      return /*#__PURE__*/React.createElement(ZIndexContext.Consumer, null, function (contextZIndex) {
        var zIndex = _this2.props.zIndex !== undefined ? _this2.props.zIndex : contextZIndex + 1;
        return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(Transition, {
          "in": isOpen,
          timeout: TRANSITION_DURATION + 200,
          appear: true,
          mountOnEnter: true,
          unmountOnExit: true,
          onEnter: _this2._handleTransitionEnter,
          onEntering: _this2._handleTransitionEntering,
          onExiting: _this2._handleTransitionExiting,
          onExited: _this2._handleTransitionExited,
          addEndListener: _this2._handleTransitionAddEndListener
        }, function (transitionState) {
          var animation = {
            enter: undefined,
            entering: 'expand',
            entered: 'expand',
            exit: 'collapse',
            exiting: 'collapse',
            exited: 'collapse',
            unmounted: undefined
          }[transitionState];
          return /*#__PURE__*/React.createElement(StyledWrapper, {
            className: className,
            "aria-label": ariaLabel,
            role: "dialog",
            tabIndex: setInitialFocusToDialog || setFallbackFocusToDialog ? -1 : undefined,
            ref: _this2._wrapperRef,
            title: _this2.props.triggerEl.id,
            style: {
              minWidth: minWidth,
              marginTop: offsetTop,
              zIndex: zIndex
            },
            "data-testid": ariaLabel || 'DropdownDialog'
          }, /*#__PURE__*/React.createElement(StyledAnimationWrapper, {
            animation: animation
          }, /*#__PURE__*/React.createElement(StyledInvertedAnimationWrapper, {
            animation: animation
          }, /*#__PURE__*/React.createElement(StyledScrollWrapper, {
            style: {
              maxHeight: maxHeight
            },
            onClick: _this2.props.onClose
          }, /*#__PURE__*/React.createElement(ZIndexContext.Provider, {
            value: zIndex
          }, children), includeA11yCloseButton && /*#__PURE__*/React.createElement(StyledA11yCloseButton, {
            type: "button",
            onClick: _this2.props.onClose
          }, "Close dropdown")))));
        }));
      });
    }
  }]);

  return DropdownDialog;
}(React.Component);
DropdownDialog.defaultProps = {
  open: true,
  closeOnEsc: true,
  closeOnOutsideClick: true,
  trapFocus: true,
  includeA11yCloseButton: true,

  /**
   * What these default values do:
   * - dropdown by default should go towards bottom-right direction
   * - in case dialog would have to leave the viewport, show it in some other direction (i.e. top/left)
   * - in case that doesn't help, pin it to scroll parent's / window's viewport
   *
   * In order to learn more about the effect of these values,
   * check out storybook stories or Tether documentation.
   */
  dialogAttachment: 'top left',
  triggerAttachment: 'bottom left',
  constraints: [{
    to: 'scrollParent'
  }, {
    to: 'window',
    attachment: 'together',
    pin: true
  }],
  'aria-label': 'Dropdown'
};
DropdownDialog.contextType = EscKeyListenContext;

export { DropdownDialog };
